import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import {
  appStore,
  artifactApiStore,
  artifactSaveStore,
  artifactStore,
} from "@/hooks";
import { TextButton, FlexBox } from "@/components/common";


/**
 * Buttons for deleting and saving an edited artifact.
 */
const __default__ = {
  name: "SaveArtifactButtons",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const canSave = computed(() => artifactSaveStore.canSave);
const isUpdate = computed(() => artifactSaveStore.isUpdate);

/**
 * Attempts to delete the selected artifact.
 */
function handleDelete(): void {
  const artifact = artifactStore.selectedArtifact;

  if (!artifact) return;

  artifactApiStore.handleDelete(artifact, {
    onSuccess: () => appStore.closeSidePanels(),
  });
}

/**
 * Attempts to save the artifact.
 */
function handleSubmit(): void {
  artifactApiStore.handleSave(
    artifactSaveStore.finalizedArtifact,
    artifactSaveStore.isUpdate,
    artifactSaveStore.parentArtifacts,
    artifactSaveStore.childArtifacts,
    {
      onSuccess: () => appStore.openDetailsPanel("displayArtifact"),
    }
  );
}

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!

  return (_openBlock(), _createBlock(_unref(FlexBox), {
    "full-width": "",
    justify: "between"
  }, {
    default: _withCtx(() => [
      (isUpdate.value)
        ? (_openBlock(), _createBlock(_unref(TextButton), {
            key: 0,
            text: "",
            loading: _unref(artifactApiStore).deleteLoading,
            label: "Delete",
            icon: "delete",
            "data-cy": "button-artifact-delete",
            onClick: handleDelete
          }, null, 8, ["loading"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_space),
      _createVNode(_unref(TextButton), {
        loading: _unref(artifactApiStore).saveLoading,
        disabled: !canSave.value,
        label: "Save",
        icon: "save",
        "data-cy": "button-artifact-save",
        onClick: handleSubmit
      }, null, 8, ["loading", "disabled"])
    ]),
    _: 1
  }))
}
}

})